var _style, _linearGradient, _linearGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMovies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bg-21",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 667.81 949.5",
    width: 286.188,
    height: 406.906,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "406.891px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "406.891px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "286.188px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "hidden",
      overflowY: "hidden",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "143.094px 203.438px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "143.094px 203.445px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "middle",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "286.188px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .cls-bg211{fill:#f8f8ff;}\n        .cls-bg212{fill:#e9edfb;}\n        .cls-bg213{fill:url(#bg21-linear-gradient);}\n        .cls-bg214{fill:#bac5f4;}\n        .cls-bg215{fill:#e1e6fb;}\n        .cls-bg216{fill:#fff;}\n        .cls-bg217{fill:none;stroke:#bac5f4;stroke-miterlimit:10;stroke-width:2px;}\n        .cls-bg218{fill:#b1c1f2;}\n        .cls-bg219{fill:#bac6f2;}\n        .cls-bg2110{fill:url(#bg21-linear-gradient-2);}\n      ")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg21-linear-gradient",
    x1: 622.26,
    y1: 514.65,
    x2: 1212.33,
    y2: 514.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg21-linear-gradient-2",
    x1: 120.58,
    y1: 611.33,
    x2: 342.48,
    y2: 611.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg211",
    d: "M633,692.81S550,270.25,747.33,188.57,878.06,14.44,992,25.19s178.44,155,195.64,289.27,83.48,450.25-26.69,486.29C1028.18,844.18,1010.15,980,895.18,973.63,672.31,961.38,633,692.81,633,692.81Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(248, 248, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg212",
    d: "M622.26,618.09l590.07-5s-200.56,7.64-202.51,72.73-25.38,121-113.21,127.68S749.44,713,637,713.61C561.28,714,622.26,618.09,622.26,618.09Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(233, 237, 251)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg213",
    d: "M622.26,618.09l590.07-5s-107.09-123.75-196.22-98.42c-63,17.89-31.67-96.23-119.5-103s-8.36,64-120.8,63.43C700.09,474.7,622.26,618.09,622.26,618.09Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg214",
    d: "M887.94,682.18h63.25s-6.15-22.84-25.47-22-19.33,11-19.33,11S885.31,669.88,887.94,682.18Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg214",
    d: "M941.53,653.19h91.36s-1.76-14.94-12.3-14.94-9.66-35.13-33.38-36S948.56,612.78,941.53,653.19Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bg215",
    points: "140.47 345.33 144.92 352.08 120.58 593.81 259.42 593.81 232.37 351.6 236.99 345.33 140.47 345.33",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(225, 230, 251)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bg214",
    points: "236.32 387.02 141.22 387.02 141.88 380.47 235.59 380.47 236.32 387.02",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg212",
    d: "M1078.36,158.67h94.4c15.17,0,23.82-17.76,14.06-29.38-5.7-6.79-16.12-11.87-34.78-11.14,0,0-26.06-49.5-62.59-.07,0,0-30-3-32.35,16.28,0,.19,0,.39-.07.57A21.44,21.44,0,0,0,1078.36,158.67Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(233, 237, 251)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg212",
    d: "M644.22,278.77H751.91c17.3,0,27.17-20.27,16-33.52-6.51-7.74-18.39-13.54-39.68-12.7,0,0-29.73-56.48-71.4-.08,0,0-34.28-3.39-36.9,18.57,0,.22-.06.43-.08.65A24.45,24.45,0,0,0,644.22,278.77Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(233, 237, 251)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bg215",
    points: "152.23 328.73 152.75 296.65 227.25 296.65 227.25 327.46 152.23 328.73",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(225, 230, 251)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bg214",
    points: "243.72 457.32 135.27 457.32 136.07 450.77 242.88 450.77 243.72 457.32",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bg214",
    points: "252.88 535.28 126.42 535.28 127.08 528.73 252.15 528.73 252.88 535.28",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-bg214",
    points: "140.47 345.33 139.77 334.64 133.76 329.01 133.76 324.93 246.29 324.93 246.29 329.06 239.85 333.55 236.99 345.33 140.47 345.33",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg216",
    d: "M784.57,342.73h9.06v-8.15s-4.07-6.79-9.06,0Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 134.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "134.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 148.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "148.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 162.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "162.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 176.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "176.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 189.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "189.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 203.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "203.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 217.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "217.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-bg217",
    x: 231.76,
    y: 314.54,
    width: 13.53,
    height: 12.22,
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "12.22px",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "12.22px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "13.53px",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "rgb(186, 197, 244)",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeOpacity: 1,
      strokeWidth: 2,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "13.53px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: "231.76px",
      y: "314.54px",
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg214",
    d: "M750.81,320.9l-3.48-1c-1-.41-2.14-2-1.37-2.71l36.6-34.77a1.47,1.47,0,0,0,.22-1.89c-.83-1.18-1.57-3.18,1.87-4.14,5.07-1.42,2.35-9.53,3.38-9.53s-.33,6.49,1.69,8.11,6.27,2.13,3.72,5.71a1.46,1.46,0,0,0,.21,1.92l36.56,34a1.49,1.49,0,0,1-.28,2.38l-3.29,1.86a1.53,1.53,0,0,1-.73.19H751.8A2,2,0,0,1,750.81,320.9Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 197, 244)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg218",
    d: "M1186.08,654.2,1186,445.34s-100.39-7.94-85.55-70.82c9.77-41.41,42.81-44.67,42-66.5-.57-15.78,13.77-80.36,57.1-45.17,34.23,27.79,18.15,50.72,35.83,54,18.11,3.34,40.2,33.79,27.92,51.65s1.39,18.53,1.39,27.46,7.26,34.89-29.58,41.59-44,8.84-44,8.84l3.1,207.84Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(177, 193, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg219",
    d: "M1130.23,656l.1-176.78s71.33-6.72,60.79-59.95c-6.94-35.07-30.42-37.82-29.85-56.31.41-13.36-9.78-68-40.57-38.24-24.33,23.53-12.9,42.94-25.46,45.69-12.87,2.83-28.56,28.61-19.84,43.73s-1,15.69-1,23.25-5.16,29.54,21,35.22,31.25,7.48,31.25,7.48l-2,176Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(186, 198, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-bg218",
    d: "M1154,662l0-105.11s-34.61-4-29.49-35.72c3.36-20.89,14.75-22.53,14.48-33.55-.2-8,4.74-40.53,19.68-22.78,11.8,14,6.26,25.58,12.35,27.22,6.25,1.69,13.86,17.05,9.63,26.06s.48,9.34.48,13.85,2.5,17.6-10.2,21-13.06,3.43-13.06,3.43l.21,105.33Z",
    transform: "translate(-599.05 -24.34)",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "path(&quot",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(177, 193, 242)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -599.05, -24.34)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-bg2110",
    points: "120.58 593.81 342.48 628.85 259.42 593.81",
    style: {
      alignContent: "normal",
      alignItems: "normal",
      alignSelf: "auto",
      alignmentBaseline: "auto",
      animationDelay: "0s",
      animationDirection: "normal",
      animationDuration: "0s",
      animationFillMode: "none",
      animationIterationCount: 1,
      animationName: "none",
      animationPlayState: "running",
      animationTimingFunction: "ease",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      backgroundAttachment: "scroll",
      backgroundBlendMode: "normal",
      backgroundClip: "border-box",
      backgroundColor: "rgba(0, 0, 0, 0)",
      backgroundImage: "none",
      backgroundOrigin: "padding-box",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      backgroundSize: "auto",
      baselineShift: 0,
      blockSize: "auto",
      borderBlockEndColor: "rgb(33, 37, 41)",
      borderBlockEndStyle: "none",
      borderBlockEndWidth: 0,
      borderBlockStartColor: "rgb(33, 37, 41)",
      borderBlockStartStyle: "none",
      borderBlockStartWidth: 0,
      borderBottomColor: "rgb(33, 37, 41)",
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      borderBottomStyle: "none",
      borderBottomWidth: 0,
      borderCollapse: "separate",
      borderEndEndRadius: 0,
      borderEndStartRadius: 0,
      borderImageOutset: 0,
      borderImageRepeat: "stretch",
      borderImageSlice: "100%",
      borderImageSource: "none",
      borderImageWidth: 1,
      borderInlineEndColor: "rgb(33, 37, 41)",
      borderInlineEndStyle: "none",
      borderInlineEndWidth: 0,
      borderInlineStartColor: "rgb(33, 37, 41)",
      borderInlineStartStyle: "none",
      borderInlineStartWidth: 0,
      borderLeftColor: "rgb(33, 37, 41)",
      borderLeftStyle: "none",
      borderLeftWidth: 0,
      borderRightColor: "rgb(33, 37, 41)",
      borderRightStyle: "none",
      borderRightWidth: 0,
      borderStartEndRadius: 0,
      borderStartStartRadius: 0,
      borderTopColor: "rgb(33, 37, 41)",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderTopStyle: "none",
      borderTopWidth: 0,
      bottom: "auto",
      boxShadow: "none",
      boxSizing: "border-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(33, 37, 41)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(33, 37, 41)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columnCount: "auto",
      columnGap: "normal",
      columnRuleColor: "rgb(33, 37, 41)",
      columnRuleStyle: "none",
      columnRuleWidth: 0,
      columnSpan: "none",
      columnWidth: "auto",
      content: "normal",
      cursor: "pointer",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "url(&quot",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flexBasis: "auto",
      flexDirection: "row",
      flexGrow: 0,
      flexShrink: 1,
      flexWrap: "nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      fontFamily: "Averta, &quot",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      fontSize: 16,
      fontStretch: "100%",
      fontStyle: "normal",
      fontVariant: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontWeight: 400,
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridColumnEnd: "auto",
      gridColumnStart: "auto",
      gridRowEnd: "auto",
      gridRowStart: "auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlockEnd: "auto",
      insetBlockStart: "auto",
      insetInlineEnd: "auto",
      insetInlineStart: "auto",
      isolation: "auto",
      justifyContent: "normal",
      justifyItems: "normal",
      justifySelf: "auto",
      left: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      lineHeight: 24,
      listStyleImage: "none",
      listStylePosition: "outside",
      listStyleType: "disc",
      marginBlockEnd: 0,
      marginBlockStart: 0,
      marginBottom: 0,
      marginInlineEnd: 0,
      marginInlineStart: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      markerEnd: "none",
      markerMid: "none",
      markerStart: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offsetDistance: 0,
      offsetPath: "none",
      offsetRotate: "auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outlineColor: "rgb(33, 37, 41)",
      outlineOffset: 0,
      outlineStyle: "none",
      outlineWidth: 0,
      overflowAnchor: "auto",
      overflowClipMargin: 0,
      overflowWrap: "normal",
      overflowX: "visible",
      overflowY: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlockEnd: 0,
      paddingBlockStart: 0,
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      right: "auto",
      rowGap: "normal",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlockEnd: 0,
      scrollMarginBlockStart: 0,
      scrollMarginInlineEnd: 0,
      scrollMarginInlineStart: 0,
      scrollPaddingBlockEnd: "auto",
      scrollPaddingBlockStart: "auto",
      scrollPaddingInlineEnd: "auto",
      scrollPaddingInlineStart: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(33, 37, 41)",
      textDecorationColor: "rgb(33, 37, 41)",
      textDecorationLine: "none",
      textDecorationSkipInk: "auto",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "100%",
      textTransform: "none",
      textUnderlinePosition: "auto",
      top: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transitionDelay: "0s",
      transitionDuration: "0s",
      transitionProperty: "all",
      transitionTimingFunction: "ease",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      WebkitBorderHorizontalSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBorderVerticalSpacing: 0,
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitBoxReflect: "none",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLineClamp: "none",
      WebkitLocale: "&quot",
      WebkitMaskBoxImage: "none",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMaskClip: "border-box",
      WebkitMaskComposite: "source-over",
      WebkitMaskImage: "none",
      WebkitMaskOrigin: "border-box",
      WebkitMaskPosition: "0% 0%",
      WebkitMaskRepeat: "repeat",
      WebkitMaskSize: "auto",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasisColor: "rgb(33, 37, 41)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextEmphasisStyle: "none",
      WebkitTextFillColor: "rgb(33, 37, 41)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStrokeColor: "rgb(33, 37, 41)",
      WebkitTextStrokeWidth: 0,
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovies);
export default __webpack_public_path__ + "static/media/movies.d0baf9821c36daf3d943843b2a285e75.svg";
export { ForwardRef as ReactComponent };